module.exports = __webpack_public_path__ + "img/iconsuccessful.da23fad9.svg";